import React, { Component } from "react";
import { StyleSheet, css } from "aphrodite";
import { Panel, Label } from "react-bootstrap";
import { connect } from "react-redux";
// import Notfy from '../notificacao'
// import NotifyContainer from '../notificacao/container'
import { contadorDeUsuarios } from "../../redux/actions/user";
import {
  changeNState,
  changeNumberOfNotify
} from "../../redux/actions/notificacoes";
class controlls extends Component {
  componentDidMount() {
    this.props.contadorDeUsuarios();
  }
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-lg-4 col-sm-6">
            <Panel bsStyle="primary">
              <Panel.Heading>
                <Panel.Title componentClass="h3">
                  <center>
                    Bem Vindo,{" "}
                    {this.props.user ? this.props.user.nome : "Usuario"}
                  </center>
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body>
                <center>
                  {this.props.user ? (
                    <div
                      className={css(styles.profileImg)}
                      style={{ background: `url(${this.props.user.img})` }}
                    />
                  ) : (
                    <div
                      className={css(styles.profileImg)}
                      style={{ background: "#fff" }}
                    />
                  )}
                </center>
              </Panel.Body>
            </Panel>
          </div>

          <div className="col-lg-4 col-sm-6">
            <Panel bsStyle="success">
              <Panel.Heading>
                <Panel.Title componentClass="h3">
                  <center>Usuários Cadastrados</center>
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body>
                <center>
                  <h1>
                    {" "}
                    <Label bsStyle="success">
                      {this.props.registered_users}
                    </Label>{" "}
                  </h1>
                  <h4 className={css(styles.titulocard)}>
                    {" "}
                    Usuários Cadastrados{" "}
                  </h4>
                </center>
              </Panel.Body>
            </Panel>
          </div>

          <div className="col-lg-4 col-sm-6">
            <Panel bsStyle="warning">
              <Panel.Heading>
                <Panel.Title componentClass="h3">
                  <center>Seus Tzbs</center>
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body>
                <center>
                  <h1>
                    {" "}
                    <Label bsStyle="warning">Em Breve</Label>{" "}
                  </h1>
                  <h4 className={css(styles.titulocard)}>
                    {" "}
                    Tzbs na sua conta{" "}
                  </h4>
                </center>
              </Panel.Body>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}
const styles = StyleSheet.create({
  profileImg: {
    width: "120px",
    height: "120px",
    backgroundSize: "100%",
    borderRadius: "50%"
  },
  titulocard: {
    marginTop: "30px"
  }
});
const mapStateToProps = state => {
  return {
    user: state.user.user,
    notificacoesState: state.notify.notificacoesState,
    numberOfNewNotify: state.notify.numberOfNewNotify,
    registered_users: state.user.registered_users
  };
};

export default connect(
  mapStateToProps,
  { changeNState, changeNumberOfNotify, contadorDeUsuarios }
)(controlls);



// WEBPACK FOOTER //
// ./src/assets/controlls/index.js